<template lang="pug">
  div.types-plans(v-if="plans.length === 2")
    fieldset.types-plans__plan-container(v-for="plan in plans" :key="plan.uuid")
      input.types-plans__plan-radio(
        type="radio"
        name="radio"
        :id="plan.uuid"
        :checked="plan.frequency === 'MONTHLY' && 'checked'"
      )
      label.types-plans__plan(:for="plan.uuid" @click="setPlan(plan.frequency)")
        div
          strong.types-plans__plan-title Plano {{ plan.frequency === 'MONTHLY' ? 'Mensal' : 'Anual'}}
          p.types-plans__plan-type {{ plan.frequency === 'MONTHLY' ? 'Recorrente' : 'Fidelidade de 1 ano'}}
        div
          p.types-plans__plan-label {{ plan.frequency === 'MONTHLY' ? 'Mês' : 'Até 12x de'}}
          strong.types-plans__plan-value {{ plan.value | currency }}
</template>
<script>
import { mapActions } from 'vuex'
import { currency } from '@/utils/filters'

export default {
  name: 'TypesPlans',
  props: {
    plans: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    currency
  },
  methods: {
    ...mapActions('payment', ['getInstallments']),
    async setPlan (typePlan) {
      const plan = this.plans.find(plan => plan.frequency === typePlan)

      // Sotre Product
      this.$store.state.product.recurrent = typePlan === 'MONTHLY'

      // Store Plan
      this.$store.state.plan.uuid = plan.uuid
      this.$store.state.plan.precoTotal = plan.totalValue
      this.$store.state.plan.name = plan.description
      this.$store.state.plan.preco = plan.value
      this.$store.state.plan.category = plan.category
      this.$store.state.plan.type = plan.planType
      this.$store.state.plan.parcela = 12
      this.$store.state.plan.parcelasPrecos = [plan.value]

      // Component InfoInsurance
      this.$store.state.product.infoInsurance[0].text = plan.description
      this.$store.state.product.infoInsurance[1].text = `Plano ${typePlan === 'MONTHLY' ? 'mensal' : 'anual'} (Sem carência)`

      if (typePlan === 'YEARLY') {
        await this.getInstallments()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .types-plans {
    display: flex;
    flex-flow: wrap;
    margin-bottom: 48px;
    margin-top: 24px;
    gap: 16px;

    &__plan-container {
      max-width: 336px;
      width: 100%;
    }

    &__plan-radio[type='radio'] {
      display: none;
    }

    &__plan {
      background-color: #FFF;
      border-radius: 8px;
      cursor: pointer;
      border: 1.5px solid #D5D5D7;
      display: flex;
      justify-content: space-between;
      padding: 16px 24px;
      transition: border 400ms, background-color 400ms;
    }

    &__plan-radio:checked ~ &__plan {
      border: 1.5px solid #004899;
      background-color: #EBF4FF;
    }

    &__plan-title,
    &__plan-value {
      font-family: $oscine-font-family;
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
    }

    &__plan-type,
    &__plan-label {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }
</style>
